// Meta Pixel is initialized in public/index.html (fbq init + PageView).
// Do not call fbq('init') from this module.

export const EPIQ_PRODUCT = {
  content_name: 'EpiQCase',
  content_ids: ['epiqcase'],
  content_type: 'product',
  value: 15.99,
  currency: 'USD',
};

function getFbq() {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return null;
  }
  return window.fbq;
}

export function createEventId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

function getCookie(name) {
  if (typeof document === 'undefined' || !document.cookie) {
    return '';
  }
  const prefix = `${name}=`;
  const parts = document.cookie.split(';');
  for (let i = 0; i < parts.length; i += 1) {
    const part = parts[i].trim();
    if (part.indexOf(prefix) === 0) {
      return decodeURIComponent(part.slice(prefix.length));
    }
  }
  return '';
}

export function getMetaClientReferenceId() {
  const parts = [];
  const fbp = getCookie('_fbp');
  const fbc = getCookie('_fbc');
  if (fbp) parts.push(`fbp:${fbp}`);
  if (fbc) parts.push(`fbc:${fbc}`);
  if (!parts.length) {
    return '';
  }
  return parts.join('|').slice(0, 200);
}

export function trackViewContent() {
  const fbq = getFbq();
  if (!fbq) return;
  fbq('track', 'ViewContent', { ...EPIQ_PRODUCT });
}

export function trackInitiateCheckout(eventID = createEventId()) {
  const fbq = getFbq();
  if (!fbq) return eventID;
  fbq(
    'track',
    'InitiateCheckout',
    {
      ...EPIQ_PRODUCT,
      num_items: 1,
    },
    { eventID }
  );
  return eventID;
}

export function trackPurchase(eventID, extras = {}) {
  const fbq = getFbq();
  if (!fbq || !eventID) return;
  fbq(
    'track',
    'Purchase',
    {
      ...EPIQ_PRODUCT,
      num_items: 1,
      ...extras,
    },
    { eventID }
  );
}
